import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import * as TanStackQueryProvider from "./integrations/tanstack-query/root-provider.tsx";
import { ThemeProvider } from "./components/themes/provider.tsx";
import { GoogleOAuthProviderWrapper } from "./integrations/google-oauth/Provider.tsx";
import { routeTree } from "./routeTree.gen";
import "./styles.css";
import reportWebVitals from "./reportWebVitals.ts";
import { Skeleton } from "@/components/ui/skeleton.tsx";

const TanStackQueryProviderContext = TanStackQueryProvider.getContext();
const router = createRouter({
  routeTree,
  context: {
    ...TanStackQueryProviderContext,
  },

  defaultPendingComponent: () => (
    <Skeleton className="h-screen w-screen rounded-none" />
  ),

  defaultViewTransition: true,

  defaultPreload: "intent",
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
  scrollToTopSelectors: ["#dashboard-scroll-parent"],
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }

  interface StaticDataRouteOption {
    // permission guards for beforeLoad (already used)
    permissionGuards?: Array<{
      resource: string;
      actions?: Array<string>;
    }>;
    // per-route title
    title?: string;

    isProblematicScrollPage?: boolean;
  }
}

// Render the app
const rootElement = document.getElementById("app");
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <GoogleOAuthProviderWrapper>
        <ThemeProvider>
          <TanStackQueryProvider.Provider {...TanStackQueryProviderContext}>
            <RouterProvider router={router} />
          </TanStackQueryProvider.Provider>
        </ThemeProvider>
      </GoogleOAuthProviderWrapper>
    </StrictMode>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

export { router as __internal_router };
